import { config } from '~app/config';

import { ampli } from '~entities/ampli';

import { findOrCreateWuid } from '@breeze/web-lib-wuid';
import { GrowthBook } from '@growthbook/growthbook-react';

export const growthBookInstance = new GrowthBook({
  apiHost: config.growthBookApiHost,
  clientKey: config.growthBookClientKey,
  enableDevMode: config.environment !== 'prod',
  attributes: { id: findOrCreateWuid() },
  trackingCallback: (experiment, result) => {
    ampli.client.track('growthbook_experiment_viewed', {
      experimentId: experiment.key,
      variantId: result.key,
    });
  },
  onFeatureUsage: (key, result) => {
    if (result.on && result.source === 'force') {
      ampli.client.track('growthbook_feature_forced', {
        feature: key,
        value: result.value,
      });
    }
  },
});

growthBookInstance.init();
